export const displayTextTranslationKeys = {
  actual_phishing: {
    1: "workforceAttacked",
    4: "emailsDelivered",
    2: "workforceClicked",
    5: "emailsClicked",
    6: "emailsBlocked",
    3: "workforceReported",
  },
  simulated_phishing: {
    1: "emailsSent",
    2: "workforceClicked",
    5: "emailsClicked",
    3: "workforceReported",
    4: "individualsCompromised",
    6: "attachmentOpened",
    7: "openRate",
  },
  training: {
    2: "completedLate",
    3: "completed",
    4: "assigned",
    1: "overdue",
  },
  malware: {
    2: "downloaded",
    4: "downloadAttempted",
    5: "unknown",
    3: "blocked",
    1: "executed",
  },
  sensitive_data_handling: {
    2: "improperlyHandled",
  },
  identity: {
    1: "workforceInvolved",
    2: "workforceEvents",
    3: "averageEventsPerPerson",
    4: "reportedIdentityActivity",
    5: "anomalousIdentityActivity",
    6: "maliciousIdentityActivity",
    7: "suspiciousIdentityActivity",
  },
} as const

type Action = keyof typeof displayTextTranslationKeys

export function getInsightTranslationKeyPrefix<T extends Action>({
  action,
  position,
}: {
  action: T
  position: keyof (typeof displayTextTranslationKeys)[T]
}) {
  // Here we map "position" to translation key, which looks absurd but works for
  // now. We'll be adding an ID to the API response to make it more sane:
  // https://mimecast.jira.com/browse/EP-1598
  const insightKey = displayTextTranslationKeys[action]?.[position]

  return `behaviorStatistics.${action}.${insightKey}`
}
